export default "__VITE_PUBLIC_ASSET__b42798ac__"